module.exports = __webpack_public_path__ + "static/media/dollarIcon.8f5ffe34.svg";